import React, { useState } from "react";
import Button from "../Button";

const Contact = ({ id }) => {
    const [formData, setFormData] = useState({
        name: "",
        email: "",
        subject: "",
        message: "",
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        // Handle form submission logic here (e.g., send data to an API)
        console.log(formData);
    };

    return (
        <section className="w-full bg-white p-5 px-[10%]" id={id}>
            <h2 className="text-[50px] font-[600] mb-2">Contact Us</h2>
            <p className="text-black mb-6 text-[18px] font-[500]">
                For enquiries and questions about our foundation, kindly reach out to us.
            </p>
            <form
                className="w-full mx-auto grid grid-cols-1 md:grid-cols-2 gap-6"
                onSubmit={handleSubmit}
            >
                <div>
                    <div className="mb-4">
                        <input
                            type="text"
                            name="name"
                            value={formData.name}
                            onChange={handleChange}
                            placeholder="Name"
                            className="w-full outline outline-[#102343] px-3 rounded h-[60px] focus:outline-none focus:ring focus:ring-[#102343] transition"
                            required
                        />
                    </div>
                    <div className="mb-4">
                        <input
                            type="email"
                            name="email"
                            value={formData.email}
                            onChange={handleChange}
                            placeholder="Email address"
                            className="w-full outline outline-[#102343] px-3 rounded h-[60px] focus:outline-none focus:ring focus:ring-[#102343] transition"
                            required
                        />
                    </div>
                    <div className="mb-4">
                        <input
                            type="text"
                            name="subject"
                            value={formData.subject}
                            onChange={handleChange}
                            placeholder="Subject"
                            className="w-full outline outline-[#102343] px-3 rounded h-[60px] focus:outline-none focus:ring focus:ring-[#102343] transition"
                            required
                        />
                    </div>
                </div>

                <div className="mb-4">
                    <textarea
                        name="message"
                        value={formData.message}
                        onChange={handleChange}
                        placeholder="Message"
                        rows="5"
                        className="w-full outline outline-[#102343] p-3 rounded h-[213px] focus:outline-none focus:ring focus:ring-[#102343] transition"
                        required
                    ></textarea>
                </div>
                <div className="flex justify-end col-span-1 md:col-span-2">
                    <Button content={"Submit"} style={""} />
                </div>
            </form>
        </section>
    );
};

export default Contact;